module.exports = __webpack_public_path__ + "static/media/siemens.dd1319b7.png";